// extracted by mini-css-extract-plugin
export default {"formHeading":"KS-z","form":"LS-z","submitBtn":"MS-z","disabled":"NS-z","input":"OS-z","error":"PS-z","submitMsg":"QS-z","signIn":"RS-z"};